import React from 'react';
import PropTypes from 'prop-types';
import SVG from 'react-inlinesvg';
import styled from 'styled-components';

import LinkButton from '../../link-button';
import iconSrc from '../../../utils/iconSrc';

const StyledSVG = styled(SVG)`
  display: inline-block;
  margin-right: ${({ theme }) => theme.spacing.tiny};
  fill: ${({ theme }) => theme.palette.royalBlue};
  width: 1em;
  height: 1em;
`;

const StartAgain = ({ cancel }) => (
  <LinkButton onClick={cancel}>
    <StyledSVG src={iconSrc('refresh')} />
    Start again
  </LinkButton>
);

StartAgain.propTypes = {
  cancel: PropTypes.func.isRequired,
};

export default StartAgain;
